import script from "./generateloanapplications.vue?vue&type=script&setup=true&lang=js"
export * from "./generateloanapplications.vue?vue&type=script&setup=true&lang=js"

import "./generateloanapplications.vue?vue&type=style&index=0&id=05080420&lang=css"

const __exports__ = script;

export default __exports__